import type { ClientKind } from '@/kinds/kind'
import { afterPatch, apply, defaults, displayName, initialStatus } from './apply'
import { projectSpec, projectStatus, type ProjectSpec, type ProjectStatus } from './schema'
import { ProjectDetail, ProjectForm, ProjectListRow } from './components'

export const projectKind: ClientKind<ProjectSpec, ProjectStatus> = {
  name: 'Project',
  version: 1,
  spec: projectSpec,
  status: projectStatus,
  defaults,
  validate: () => [],
  initialStatus,
  displayName,
  apply,
  afterPatch,
  actions: ['complete', 'drop', 'pause', 'resume', 'touch', 'convert'],
  ListRow: ProjectListRow,
  Detail: ProjectDetail,
  Form: ProjectForm,
  workspaceScoped: true,
}

export * from './schema'
export type { ProjectResource } from './apply'
